import React, { useState } from "react";
import { Button, Dropdown, message, Modal, Tooltip } from "antd";
import { FileZipOutlined, SaveFilled } from "@ant-design/icons";
import { CloudArrowDownIcon } from "@heroicons/react/24/solid";
import { CollapseFolderExport } from "./CollapseFolderExport.tsx";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { getExportFolderDropdownItems } from "./fixtures/getExportFolderDropdownItems.tsx";
import { useAppDispatch } from "../../redux/hooks.ts";
import { downloadFolderAsZip } from "../../redux/actions/folderActions.tsx";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  folder: Folder;
}

export const ExportFolder: React.FC<Props> = ({ folder }) => {
  const dispatch = useAppDispatch();

  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const downloadOptions = [
    {
      label: "Descargar zip",
      icon: <FileZipOutlined />,
      action: async () => await onExportFolderAsZip(),
    },
    //{label: 'Reenviar link', icon: <LinkOutlined/>, action: () => console.log('Reenviar link')},
    //{label: 'Copiar link', icon: <LinkOutlined/>, action: () => console.log('Copiar link')},
  ];
  const items = getExportFolderDropdownItems(downloadOptions);

  const onExportFolderAsZip = async () => {
    try {
      setIsLoading(true);
      await dispatch(
        downloadFolderAsZip({
          folder_id: folder.id,
          folder_number: folder.folder_number,
        }),
      ).unwrap();
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo exportar el expediente."));
    } finally {
      setIsLoading(false);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      {contextHolder}
      <Modal
        open={open}
        title="Exportar expediente"
        onCancel={onClose}
        footer={
          <Dropdown menu={{ items }}>
            <Button type="primary" loading={isLoading} icon={<SaveFilled />}>
              Descargar
            </Button>
          </Dropdown>
        }
        width="60vw"
        centered
      >
        <div className="space-y-4">
          <CollapseFolderExport folder={folder} />
        </div>
      </Modal>
      <Tooltip title="Exportar expediente" className="cursor-pointer">
        <CloudArrowDownIcon
          color="gray"
          className="h-6 w-6 text-gray-600 hover:text-blue-400"
          onClick={onOpen}
        />
      </Tooltip>
    </div>
  );
};
